module.exports = __webpack_public_path__ + "img/de.015653b.svg";